"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var safe_access_1 = __importDefault(require("safe-access"));
var nucleus_1 = require("@lifesize/nucleus");
var pairing_1 = require("../constants/pairing");
var pairing_2 = __importDefault(require("../actions/pairing"));
var remoting_1 = __importDefault(require("../actions/remoting"));
var DEVICE_INFO_NAME_CHANGE = nucleus_1.nucleusConstants.DEVICE_INFO_NAME_CHANGE;
var pairingMiddleware = function (store) { return function (next) { return function (action) {
    var result = next(action);
    var handler = actionMap[action.type];
    if (handler) {
        handler(store, action);
    }
    return result;
}; }; };
exports.default = pairingMiddleware;
var actionMap = (_a = {},
    _a[pairing_1.actions.WAMP_SUBSCRIPTION_LINKING_EVENT] = handleLinkingEvent,
    _a[pairing_1.actions.REMOTE_UNLINK_BEGIN] = handleRemoteUnlinkBegin,
    _a);
var eventMap = (_b = {},
    _b[pairing_1.subscriptionEventTypes.linked] = handleLinked,
    _b[pairing_1.subscriptionEventTypes.unlinked] = handleUnlinked,
    _b[pairing_1.subscriptionEventTypes.unpaired] = handleUnpaired,
    _b[pairing_1.subscriptionEventTypes.licenseUpdate] = handleLicenseUpdate,
    _b[pairing_1.subscriptionEventTypes.pairingCodeUpdate] = handlePairingCodeUpdate,
    _b[pairing_1.subscriptionEventTypes.settingsChanged] = handleDeviceSettingsChange,
    _b[DEVICE_INFO_NAME_CHANGE] = handleDeviceInfoNameChange,
    _b);
function handleLinked(store, payload) {
    var state = store.getState();
    var isDisplay = safe_access_1.default(state, 'app.remoting.pairing.isDisplay');
    var pairingUUID = safe_access_1.default(state, 'app.remoting.pairing.uuid');
    var serialNumber = safe_access_1.default(state, 'nucleus.device.serialNumber');
    var isDashTabletLinking = payload.linkType === pairing_1.linkedDeviceTypes.tablet;
    var isDashPresenterLinking = payload.linkType === pairing_1.linkedDeviceTypes.presenter;
    var isGEMSTabletLinking = payload.linkType === pairing_1.linkedDeviceTypes.gemsTablet;
    var isGEMSPresenterLinking = payload.linkType === pairing_1.linkedDeviceTypes.gemsPresenter;
    // if Dash display is linking tablet, check for pairing.uuid
    if (payload.linkedUUID && isDashTabletLinking && payload.deviceUUID === pairingUUID && isDisplay) {
        store.dispatch(pairing_2.default.getDeviceInfo());
        store.dispatch({ type: pairing_1.actions.REMOTE_LINKED });
    }
    // if Dash display is linking presenter, check for pairing.uuid
    else if (payload.linkedUUID && isDashPresenterLinking && payload.deviceUUID === pairingUUID && isDisplay) {
        store.dispatch(pairing_2.default.getDeviceInfo());
    }
    // if GEMS is linking tablet, check for serial number
    else if (payload.linkedUUID && isGEMSTabletLinking && payload.deviceUUID === serialNumber) {
        store.dispatch(pairing_2.default.getDeviceInfo());
    }
    // if GEMS is linking presenter, check for serial number
    else if (payload.linkedUUID && isGEMSPresenterLinking && payload.deviceUUID === serialNumber) {
        store.dispatch(pairing_2.default.getDeviceInfo());
    }
}
function handleUnlinked(store, payload) {
    var state = store.getState();
    var isDisplay = safe_access_1.default(state, 'app.remoting.pairing.isDisplay');
    if (payload.unlinkedUUID && isDisplay) {
        // a linked device (remote or presenter) has unlinked (update the full array with getDeviceInfo)
        store.dispatch(pairing_2.default.getDeviceInfo());
        store.dispatch({ type: pairing_1.actions.REMOTE_UNLINK_SUCCESS });
    }
}
function handleUnpaired(store) {
    // the value of deviceUUID (received by display) or linkedDeviceUUID (received by presenter) is not relevant at this time
    store.dispatch(remoting_1.default.displayUnpaired());
}
function handleDeviceInfoNameChange(store, payload) {
    store.dispatch(nucleus_1.userProfileActions.updateName(payload.name));
}
function handleLicenseUpdate(store) {
    // re-checkin upon receiving a license update
    store.dispatch(nucleus_1.userProfileActions.getUserProfile());
}
function handleLinkingEvent(store, action) {
    var payload = safe_access_1.default(action, 'payload');
    var eventType = safe_access_1.default(payload, 'eventType');
    var handler = eventMap[eventType];
    if (handler) {
        handler(store, payload);
    }
}
function handleRemoteUnlinkBegin(store) {
    store.dispatch(pairing_2.default.unlinkDisplay());
}
function handlePairingCodeUpdate(store, payload) {
    var eventType = safe_access_1.default(payload, 'eventType');
    var pairingCode = safe_access_1.default(payload, 'pairingCode');
    store.dispatch({ type: eventType, payload: pairingCode });
}
function handleDeviceSettingsChange(store, payload) {
    var event = safe_access_1.default(payload, 'eventType');
    store.dispatch({ type: event, payload: payload });
}
